import { AxiosResponse } from 'axios';
import { SignalApiUrls } from '../../../urls';
import { HttpClient } from '../../../HttpClient';
import { CsvFilePostResponse, CsvFileSummary } from '../../../types';

export default class CsvLocationsFileClient extends HttpClient {
  async getCsvLocationsFileList(
    partnerId: string,
  ): Promise<AxiosResponse<CsvFileSummary[]>> {
    const response = await this.get<AxiosResponse<CsvFileSummary[]>>(
      SignalApiUrls.getCsvLocationsFiles(partnerId),
    );
    return response;
  }

  async deleteCsvLocationsFile(
    partnerId: string,
    fileId: string,
  ): Promise<void> {
    await this.delete(SignalApiUrls.deleteCsvLocationsFile(partnerId, fileId));
  }

  async createCsvLocationsFile(
    partnerId: string,
    dto: any,
  ): Promise<AxiosResponse<CsvFilePostResponse>> {
    const token = (await this.factory.loginService.getUser()).idToken;
    const response = await this.post<AxiosResponse<any>>(
      SignalApiUrls.createCsvLocationsFile(partnerId),
      dto,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return response;
  }
}
